import * as React from "react";
import * as _ from "lodash";

import {PrivilegeDto} from "../../../services/Client";

import SelectField, {SelectedValue} from "../../../components/SelectField";

export interface IPrivilegeSelectionProps {
    /** Displayed when there's no privilege selected. */
    placeholder?: string;

    /** Data source array. All available privileges. */
    privileges: PrivilegeDto[];

    /** Initially selected privileges. */
    values?: PrivilegeDto[];

    /** Callback when the selected privileges change. */
    onChange?: (privileges: PrivilegeDto[]) => any;
}

/** Return the PrivilegeDto references from the privileges array that match values. */
const selectPrivileges = (privileges: PrivilegeDto[], values: PrivilegeDto[]): PrivilegeDto[] => (
    privileges.filter(privilege => _.find(values, value => value.identifier === privilege.identifier) !== undefined)
);

/**
 * PrivilegeSelection is a select field component enables the selection of
 * privileges for RoleDtos. There may be 0..* privileges selected.
 */
export const PrivilegeSelection = (props: IPrivilegeSelectionProps) => {
    const selectedValues = selectPrivileges(props.privileges, props.values ? props.values : []);
    return (
        <SelectField
            placeholder={props.placeholder}
            multi={true}
            searchable={false}
            clearable={false}
            dataSource={props.privileges}
            value={selectedValues}
            rendererKey={(option: PrivilegeDto) => option.identifier}
            onChange={(selectedValue: Array<SelectedValue>) => {
                if (props.onChange) {
                    const privileges = selectedValue.map(value => value.selectedValue as PrivilegeDto);
                    props.onChange(privileges);
                }
            }}
        />
    );
};

export default PrivilegeSelection;



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/PrivilegeSelection.tsx